import React from "react";
import { Link } from "react-router-dom";
import AnimatedCounter from "@/components/AnimatedCounter";
import { ArrowRight } from "@phosphor-icons/react";

export default function HomeBrainHealthSection() {
  return (
    <section className="md-section brain-health-md-section" data-testid="brain-health-section">
      <div className="brain-health-card" style={{ backgroundImage: "url(/img/brain-health.jpg)" }} data-testid="brain-health-card">
        <div className="brain-health-overlay" aria-hidden />
        <div className="md-container brain-health-content">
          <div className="brain-health-eyebrow-pill">Welcome to <span className="md-brand">MindDhara</span></div>
          <h2 className="font-serif brain-health-headline" data-testid="brain-health-headline">
            Rewiring <span className="hw-title-soft">Human Intelligence</span>
          </h2>
          <p className="brain-health-subhead">
            We believe that the goal of mental health should be not better performance but ease of life.{" "}
            <span className="md-brand">MindDhara</span> was created to support brain health at every stage of life, from training the
            professionals who provide care, to conducting research that drives innovative
            solutions, to promoting focus, resilience, and everyday well-being, and to guiding
            individuals as they navigate life after a severe diagnosis.
          </p>
          <Link to="/about?source=home-brain-health" className="btn-primary brain-health-card-cta" data-testid="brain-health-explore-cta">
            Explore More <ArrowRight size={16} weight="bold" />
          </Link>
        </div>
      </div>

      <div className="md-container brain-health-stats-overlap">
        <div className="welcome-stats-v2" data-testid="welcome-stats">
            <div className="welcome-stat-v2" data-testid="stat-families">
              <div className="welcome-stat-v2-num">
                <AnimatedCounter to={120} suffix="+" />
              </div>
              <div className="welcome-stat-v2-divider" aria-hidden />
              <div className="welcome-stat-v2-label">Families Served</div>
            </div>
            <div className="welcome-stat-v2" data-testid="stat-nationalities">
              <div className="welcome-stat-v2-num">
                <AnimatedCounter to={6} suffix="+" />
              </div>
              <div className="welcome-stat-v2-divider" aria-hidden />
              <div className="welcome-stat-v2-label">Nationalities</div>
            </div>
            <div className="welcome-stat-v2 welcome-stat-v2-accent" data-testid="stat-rating">
              <div className="welcome-stat-v2-num">
                <AnimatedCounter to={5.0} decimals={1} suffix="★" />
              </div>
              <div className="welcome-stat-v2-divider" aria-hidden />
              <div className="welcome-stat-v2-label">Average Rating</div>
            </div>
            <div className="welcome-stat-v2" data-testid="stat-languages">
              <div className="welcome-stat-v2-num">
                <AnimatedCounter to={12} suffix="+" />
              </div>
              <div className="welcome-stat-v2-divider" aria-hidden />
              <div className="welcome-stat-v2-label">Languages</div>
            </div>
          </div>
        </div>
    </section>
  );
}
